import { Navigate, useLocation } from "react-router-dom";
import { ehLinkAntigoDoCadinFederal } from "./contaCorrenteSlugs";

/**
 * GEN-3984 (13/10) — o CADIN Federal saiu de Certidões: o link antigo `/certidoes?type=cadin_federal`
 * (favorito, e-mail, atalho) cai na sub-página dele na Conta Corrente. As demais certidões seguem iguais.
 * O módulo decide o resto (sem o produto ou sem a federal, cai na primeira sub-página que o usuário vê).
 */
export function LinkAntigoDoCadinFederal({ children }: { children: JSX.Element }) {
  const location = useLocation();
  if (ehLinkAntigoDoCadinFederal(location.search)) return <Navigate to="/conta-corrente/cadin-federal" replace />;
  return children;
}
